var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--on-surface)",
    d: "M2 9.2c0-2.52 0-3.78.49-4.743A4.5 4.5 0 0 1 4.457 2.49C5.42 2 6.68 2 9.2 2h5.6c2.52 0 3.78 0 4.743.49a4.5 4.5 0 0 1 1.966 1.967C22 5.42 22 6.68 22 9.2v5.6c0 2.52 0 3.78-.49 4.743a4.5 4.5 0 0 1-1.967 1.966C18.58 22 17.32 22 14.8 22H9.2c-2.52 0-3.78 0-4.743-.49a4.5 4.5 0 0 1-1.967-1.967C2 18.58 2 17.32 2 14.8V9.2Z",
    opacity: 0.13
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--on-surface)",
    fillRule: "evenodd",
    d: "M10.381 8.062c-.098.124-.179.275-.24.452-.18.523-.589.986-1.141.986s-1.014-.452-.916-.995c.106-.584.324-1.178.736-1.692C9.506 5.955 10.58 5.5 12 5.5c1.457 0 2.515.445 3.19 1.216.651.744.81 1.639.81 2.284 0 .934-.24 1.653-.669 2.225-.385.514-.884.846-1.237 1.08-.013.01-.026.018-.04.027-.396.264-.623.427-.785.643a1.249 1.249 0 0 0-.225.528c-.054.27-.268.497-.544.497h-1c-.276 0-.504-.225-.476-.5.072-.696.295-1.26.645-1.725.385-.514.884-.846 1.237-1.08.013-.01.026-.018.04-.027.396-.264.623-.427.785-.643.134-.178.269-.46.269-1.025 0-.355-.091-.71-.315-.966-.2-.23-.643-.534-1.685-.534-.979 0-1.405.295-1.619.562Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--on-surface)",
    d: "M13.5 17a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
  })));
};
export default SvgHelp;